const ClientSideFile = (file: File) => ({
  name(): string {
    return file.name
  },
  size(): string {
    return (file.size / 1024 / 1024).toFixed(2)
  },
  type: 'client' as const,
  file
})

export default ClientSideFile
